/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RejectMakeupChangeRequest
 */
export interface RejectMakeupChangeRequest {
    /**
     * 
     * @type {string}
     * @memberof RejectMakeupChangeRequest
     */
    note: string;
}

/**
 * Check if a given object implements the RejectMakeupChangeRequest interface.
 */
export function instanceOfRejectMakeupChangeRequest(value: object): value is RejectMakeupChangeRequest {
    if (!('note' in value) || value['note'] === undefined) return false;
    return true;
}

export function RejectMakeupChangeRequestFromJSON(json: any): RejectMakeupChangeRequest {
    return RejectMakeupChangeRequestFromJSONTyped(json, false);
}

export function RejectMakeupChangeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RejectMakeupChangeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'note': json['note'],
    };
}

export function RejectMakeupChangeRequestToJSON(json: any): RejectMakeupChangeRequest {
    return RejectMakeupChangeRequestToJSONTyped(json, false);
}

export function RejectMakeupChangeRequestToJSONTyped(value?: RejectMakeupChangeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'note': value['note'],
    };
}

